export default "__VITE_ASSET__Cq9rgPSC__"